import { JOBS_URL } from "@/utils/constants"

const WORK_ORDER_URL = JOBS_URL

const WORK_ORDER = () => `${WORK_ORDER_URL}`
const WORK_ORDER_BY_ID = (id: string) => `${WORK_ORDER_URL}/${id}`

export default {
  WORK_ORDER,
  WORK_ORDER_BY_ID,
}
